import React, { useState, useEffect } from "react";
import "./ChassisToRC.css";

export default function ChassisToRC() {

  const [user, setUser] = useState(null);
  const [chassis, setChassis] = useState("");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser){
      setUser(storedUser);
      loadHistory(storedUser.id);
    }
  }, []);

  const loadHistory = async (uid) => {
    try {
      const res = await fetch(
        "https://rcfinder.online/api/get_chassis_history.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ identity: uid })
        }
      );

      const result = await res.json();
      if(result.success){
        setRecords(result.records);
      }

    } catch {
      console.log("History fetch failed");
    }
  };


  // 🔥 Wallet Fresh From DB (SAFE)
  const refreshWallet = async () => {
    try{
      const res = await fetch(
        `https://rcfinder.online/api/get_user.php?id=${user.id}`,
        { cache:"no-store" }
      );

      const text = await res.text();
      if(!text || text[0] !== "{") return;

      const result = JSON.parse(text);
      const freshUser = result.user || result.data || null;

      if(result.status && freshUser){
        localStorage.setItem("user", JSON.stringify(freshUser));
        setUser(freshUser);
      }

    }catch(e){
      console.log("Wallet refresh failed");
    }
  };


  const handleSearch = async () => {
    if (!chassis) return setError("Enter Chassis Number");
    if (!user?.id) return setError("User identity missing");

    setError("");
    setLoading(true);

    try {
      const res = await fetch(
        "https://rcfinder.online/api/chassis_to_rc.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            chassis_no: chassis,
            identity: user.id
          }),
        }
      );

      const result = await res.json();

      if (!result.success) {
        setError(result.message || "No record found");
      } 
      else {

        // 🔥 SweetAlert Popup
        import("sweetalert2").then((Swal)=>{
          Swal.default.fire({
            title: "Vehicle Found Successfully 🚗",
            html: `
              <b>Vehicle No:</b> ${result.vehicle || "—"} <br>
              Wallet Deducted Successfully ✔
            `,
            icon: "success",
            confirmButtonColor: "#1f57ff",
          });
        });

        // Temporary UI wallet update
        if(result.wallet){
          let u = { ...user, wallet_balance: result.wallet };
          localStorage.setItem("user", JSON.stringify(u));
          setUser(u);
        }

        // Fresh wallet DB se
        await refreshWallet();

        // Reload history
        loadHistory(user.id);
      }

    } catch {
      setError("Something went wrong, please try again");
    }

    setLoading(false);
  };


  return (
    <div className="chassis-wrapper">

      <h2 className="title">Chassis ➝ Vehicle Number</h2>
      <div className="divider"></div>

      <div className="top-row">
        <div className="left-box">
          <div className="card">

            <input
              type="text"
              placeholder="Enter Chassis Number"
              value={chassis}
              onChange={(e) => setChassis(e.target.value.toUpperCase())}
              className="input"
            />

            <button
              className="btn"
              onClick={handleSearch}
              disabled={loading}
            >
              {loading ? "Please Wait..." : "Search (₹65/-)"}
            </button>

            {error && <p className="error">{error}</p>}

            <p className="dotted-info">
              Get your Vehicle Number using Chassis Number Instantly
            </p>

          </div>
        </div>
      </div>


      <div className="history-section">
        <div className="history-card">

          <h3>Chassis ➝ Vehicle History</h3>

          <table className="history-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Chassis Number</th>
                <th>Vehicle Number</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>

              {records.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{textAlign:"center"}}>
                    No History Found
                  </td>
                </tr>
              ) : (
                records.map((r,i)=>(
                  <tr key={r.id}>
                    <td>{i+1}</td>
                    <td>{r.chassis_no}</td>
                    <td>{r.vehicle_no}</td>
                    <td>{r.created_at}</td>
                  </tr>
                ))
              )}

            </tbody>
          </table>

        </div>
      </div>

    </div>
  );
}
